import React, { useState, useEffect } from 'react';

const TruncatedText = ({ text }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const maxLength = isMobile ? 10 : 15;
  const truncatedText = text.length > maxLength ? text.slice(0, maxLength) + "..." : text;

  return <span className='title-product-card'>{truncatedText}</span>;
};

export default TruncatedText;
